import { render } from "./SidenavCard.vue?vue&type=template&id=2c6e8cc0&scoped=true"
import script from "./SidenavCard.vue?vue&type=script&lang=js"
export * from "./SidenavCard.vue?vue&type=script&lang=js"

import "./SidenavCard.vue?vue&type=style&index=0&id=2c6e8cc0&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6e8cc0"]])

export default __exports__